import { Title } from 'shared';
import React from 'react';

import { useTranslation } from 'hooks/useTranslation';

import { SecondStep } from 'features/get-started/components/SecondStep';

export const SecondStepPage = () => {
  const { t } = useTranslation('get-started');

  return (
    <>
      <Title title={t('addFunds')} />
      <SecondStep />
    </>
  );
};
